// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161114/js/" + chunkId + "." + {"44":"8ba29402","225":"21b9b916","481":"bf3a4198","486":"4059ee83","770":"82291a46"}[chunkId] + ".0.13234735357854366.chunk.js";
};